/**
 * Empty Chat Widget Surface
 *
 * Shared visual primitives for empty-chat dashboard widgets.
 *
 * Primary responsibilities:
 * - Keep widget tiles visually consistent
 * - Centralize hover, focus, and sizing states
 *
 * Dependencies:
 * - Tailwind CSS theme tokens
 */

export const EMPTY_WIDGET_SURFACE_CLASS =
  'border-border/60 bg-card/95 hover:border-foreground/15 focus-visible:ring-primary/30 flex size-full min-w-0 rounded-xl border p-4 text-left shadow-[0_10px_30px_-24px_rgba(15,23,42,0.55)] transition-[transform,box-shadow,border-color,background-color] duration-200 ease-out hover:-translate-y-0.5 hover:shadow-[0_18px_42px_-26px_rgba(15,23,42,0.55)] focus-visible:outline-none focus-visible:ring-2 active:translate-y-0 active:scale-[0.99]'

export const EMPTY_WIDGET_MUTED_CHIP_CLASS =
  'border-border/60 bg-muted/45 hover:bg-muted text-foreground inline-flex min-w-0 items-center rounded-full border px-3 py-1 text-xs transition-colors'
